module.exports = __webpack_public_path__ + "media/assets/books-glasses-round-b89fde178a16802663d5718ee4eea635.svg";